import { render, staticRenderFns } from "./localization.vue?vue&type=template&id=69c27506&"
import script from "./localization.vue?vue&type=script&lang=js&"
export * from "./localization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports